import * as RadioGroup from '@radix-ui/react-radio-group'

import { styled } from '~/styled'

export const RadioButtonGroup = styled(RadioGroup.Root, {
  base: ['flex', 'flex-wrap'],
  variants: {
    direction: {
      row: ['*:not-last:mr-8', 'flex-row'],
      column: ['flex-col']
    }
  }
})

RadioButtonGroup.displayName = 'RadioButtonGroup'
